"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Utils {
    static buildVersionMessage(version, buildTimestamp) {
        if (!version || !buildTimestamp) {
            return 'unknown';
        }
        const buildDate = new Date(parseInt(buildTimestamp, 10)).toISOString();
        return `${version}_${buildDate}`;
    }
    static extractDomainFrom(url) {
        let domain;
        if (url.includes('://') || url.indexOf('//') === 0) {
            domain = url.split('/')[2];
        }
        else {
            domain = url.split('/')[0];
        }
        domain = domain.split(':')[0];
        return domain;
    }
}
exports.Utils = Utils;
Utils.hexadecimalPrefix = '0x';
